module.exports = __webpack_public_path__ + "media/images/marketing/intensive-pricing-6528131cbc5b37c7963c09b90fa648644bc14074ac6be448c33fc059ab2757c1.jpg";